module.exports = __webpack_public_path__ + "static/media/blue-parrotfish.fa300230.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/fish/blue-parrotfish.png
// module id = 302
// module chunks = 0